/* Riders Parts — "How to read a parts diagram" on /pages/oem-parts.
 *
 * Pairs a numbered pin on the schematic with its row in the list, and writes
 * the exact sentence the customer should send us. The point of the section is
 * to produce that sentence: the request flow further down the page asks for a
 * callout number and a VIN, and most people do not know what either means until
 * they have seen one.
 *
 * Lives in an asset, never inline — an inline script in a section once printed
 * its own source as visible text across every page of the live site.
 */
(function () {
  function init(root) {
    if (root.dataset.rpPdReady) return;
    root.dataset.rpPdReady = '1';

    var svg = root.querySelector('.rp-pd__svg');
    var out = root.querySelector('[data-rp-pd-out]');
    var cta = root.querySelector('[data-rp-pd-cta]');
    var pins = [].slice.call(root.querySelectorAll('.rp-pd__pin'));
    var rows = [].slice.call(root.querySelectorAll('.rp-pd__row'));
    var art = [].slice.call(root.querySelectorAll('.rp-pd__art > g'));
    if (!pins.length || !rows.length) return;

    var baseHref = cta ? cta.getAttribute('href') : null;
    var placeholder = out ? out.textContent : '';
    var current = null;

    function nameFor(n) {
      var row = rows.filter(function (r) { return r.dataset.part === n; })[0];
      if (!row) return null;
      var el = row.querySelector('.rp-pd__name');
      return el ? el.textContent.trim() : null;
    }

    function clear() {
      current = null;
      pins.concat(rows).forEach(function (el) { el.classList.remove('is-on'); });
      art.forEach(function (g) { g.classList.remove('is-on'); });
      if (svg) svg.classList.remove('is-focusing');
      if (out) out.textContent = placeholder;
      if (cta && baseHref) cta.setAttribute('href', baseHref);
    }

    function select(n) {
      if (current === n) { clear(); return; }   // click the same number to reset
      current = n;
      pins.concat(rows).forEach(function (el) {
        el.classList.toggle('is-on', el.dataset.part === n);
      });
      art.forEach(function (g) { g.classList.toggle('is-on', g.dataset.art === n); });
      if (svg) svg.classList.add('is-focusing');

      var label = nameFor(n);
      if (out && label) {
        out.textContent = 'Write: "Item ' + n + ' — ' + label +
          '" and include your year, make, model and VIN. We reply with the exact part number, price and lead time.';
      }
      // Carry the choice into the contact link so the counter sees it too.
      if (cta && baseHref && label) {
        var subject = 'OEM part request — item ' + n + ', ' + label;
        cta.setAttribute('href',
          baseHref.indexOf('mailto:') === 0
            ? baseHref + (baseHref.indexOf('?') > -1 ? '&' : '?') + 'subject=' + encodeURIComponent(subject)
            : baseHref);
      }
    }

    function wire(el) {
      var n = el.dataset.part;
      el.addEventListener('click', function () { select(n); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(n); }
        if (e.key === 'Escape') clear();
      });
      // Hover previews without committing, so the diagram reads at a glance.
      el.addEventListener('mouseenter', function () {
        if (current) return;
        pins.concat(rows).forEach(function (x) { x.classList.toggle('is-on', x.dataset.part === n); });
        art.forEach(function (g) { g.classList.toggle('is-on', g.dataset.art === n); });
      });
      el.addEventListener('mouseleave', function () {
        if (current) return;
        pins.concat(rows).forEach(function (x) { x.classList.remove('is-on'); });
        art.forEach(function (g) { g.classList.remove('is-on'); });
      });
    }
    pins.forEach(wire);
    rows.forEach(wire);
  }

  function boot() {
    document.querySelectorAll('.rp-pd').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
